import * as types from '../mutation-types'
import {api} from '@/api'
import Vue from 'vue'
import { Store } from 'vuex';
//商场要使用的变量
const userModule = {
    state: {
      marketOption:{
        brandConfigureVoList:[],
        channelConfigureVoList:[],
        regionConfigureVoList:[]
      }
    },

    //激发事件改变state
    mutations: {
      setMarketOption({marketOption},option){
        for(let key in marketOption){
          if(Array.isArray(option[key])){
            marketOption[key]=option[key]
          }else{
            marketOption[key]=[]
          }
        }
      }
    },
    actions: {

    },

    //频繁通用计算
    getters: {

    }
}

export default userModule;
